import GemDrawerMenu from "components/common/DrawerMenu";
import { useEffect } from "react";

import { Box, Card, CardHeader } from "@mui/material";
import { DataGrid, gridStringOrNumberComparator, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import {
  GridToolbarQuickFilter,
} from '@mui/x-data-grid/components';
import { useUser, useVehicles } from "contexts";
import { formatDistanceToNow } from "date-fns";

function VehiclesPage() {
  const { context: user_context, register_user } = useUser();
  const { user } = user_context;
  useEffect(() => {
    register_user();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const { dispatch, vehicles } = useVehicles();

  let f_map = Object.assign({ "Any Field": { id: "Any Field", type: "Text" }}, vehicles.meta_map);
  let f_list = Array.from(vehicles.display_names);

  const columns = [
    // { field: "displayName", headerName: "Name", width: 150, type: 'string' },
        {
          field: 'vehicle',
          headerName: 'Vehicle',
          width: 150,
          valueGetter: (value, row, column, apiRef) => {
            return row?.displayName ?? '';
          },
          renderCell: (params) => {
            return (
              <a href={`vehicle/${params.row.id}`} rel="noopener noreferrer">
                {params.row.displayName}
              </a>
            );
          },
          getSortComparator: (sortDirection) => {
            const modifier = sortDirection === 'desc' ? -1 : 1;
            return (value1, value2, cellParams1, cellParams2) => {
              return (
                modifier *
                gridStringOrNumberComparator(value1?.identifier, value2?.identifier, cellParams1, cellParams2)
              );
            };
          }
        },  
    
    { field: "positionedAt", headerName: "Positioned", width: 230, type: 'string' },
    { field: "timeSincePositioned", headerName: "Time Since Positioned", width: 150, type: 'string' },
    { field: "isElectric", headerName: "Electric", width: 150, type: 'boolean' },
    { field: "stateOfCharge", 
      headerName: "Charge / Fuel", 
      width: 150, 
      type: 'string', 
      valueGetter: (value, row) => {
        // console.log("params row", row);
        if (row.isElectric && row.stateOfCharge) {
          return `${row.stateOfCharge}%`;
        } else if (row.fuelLevel) {
          return `${row.fuelLevel}%`;
        }
        // return row.isElectric ? `${row.stateOfCharge}%` : `${row.fuelLevel}%`;
      }
    },
    {
      field: "route",
      headerName: "Route",
      width: 350,
      type: 'string',
      valueGetter: (value, row) => {
        return row.route ? row.route.shortName+":"+row.route.name : '';
      }

    },

  ];

  // console.log("Columns configuration:", columns);

  function formatDistanceDay(date) {
    if (!date) return '';
    return formatDistanceToNow(date, { addSuffix: true }).replace('about ', '').replace('less than a', '1');
  }


  const rows = vehicles.vehicles;

  rows?.forEach(vehicle => {
    // console.log(`Vehicle ID: ${vehicle.identifier}, Time Since Positioned: ${calculateTimeSincePositioned(vehicle.positionedAt)}`);
    // console.log(`Vehicle ID: ${vehicle.identifier}, Time Since sPositioned: ${formatDistanceDay(vehicle.positionedAt)}`);    
    vehicle.timeSincePositioned = formatDistanceDay(vehicle.positionedAt);
  });


  // console.log("VehiclesPage: vehicles", vehicles.vehicles);

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector
          slotProps={{ tooltip: { title: 'Change density' } }}
        />
        <GridToolbarExport
          slotProps={{
            tooltip: { title: 'Export data' },
            button: { variant: 'outlined' },
          }}
        />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }


  return (
    <Box display="flex" width="100%" >
      <GemDrawerMenu />

      <Box
        sx={{ flexGrow: 1, padding: '5px' }}>
        <Card>
          <Box sx={{ backgroundColor: '#07A0C3', width: '100%', padding: '0px' }}>
            <CardHeader title="Vehicles" sx={{ height: '60px' }}/>
          </Box>
          <DataGrid
            initialState={{ 
              density: 'compact',
              pagination: { paginationModel: { pageSize: 25 } }
            }}
            columns={columns}
            pageSize={5}
            disableSelectionOnClick
            slots={{
              toolbar: CustomToolbar,
            }}
            rows={rows}
            rowsPerPageOptions={[5]}

          />
        {/* <ControlComponent
          style={{ display:"flex", width: "60%", justifyContent: "flex-start", alignItems: "center", padding: "10px" }}
          fields={f_list}
          field_map={f_map}
          control_map={vehicles.header}
          on_update={(filters) => {
            dispatch({
              type: "SET_FILTERS",
              payload: filters
            });

            dispatch({
              type: "FILTER_VEHICLES",
              payload: filters,
            });
          }}
        />
        <VehicleTable /> */}
        {/* <VehicleCreationForm /> */}
      </Card>
      </Box>
    </Box>
  );
}

export default VehiclesPage;
